import { render, staticRenderFns } from "./SavedNotes.vue?vue&type=template&id=4f4a8a62&"
import script from "./SavedNotes.vue?vue&type=script&lang=js&"
export * from "./SavedNotes.vue?vue&type=script&lang=js&"
import style0 from "./SavedNotes.vue?vue&type=style&index=0&id=4f4a8a62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports